<template>
  <div class="profil-container">
    <need-review :title="'Need Review'" :modalClose="close" :submit="needReview" v-if="is_catatan_open" />
    <h3 class="profil-title">
      Terima Kasih
    </h3>
    <div class="instruction-wrapper">
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Formulir Pra-Kualifikasi K3L ini telah diisi oleh Perusahaan yang
          mengajukan dengan sebenar-benarnya.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Semua data yang diisikan dan/atau lampiran dokumen pendukung adalah
          benar dan akurat pada saat dokumen formulir Pra-Kualifikasi K3L ini
          diserahkan ke pihak PT Berau Coal.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Jika data yang diisikan dan/atau lampiran dokumen pendukung yang
          diberikan tidak benar, tidak akurat dan tidak diketahui oleh Pimpinan
          Tertinggi Perusahaan maka tidak akan diperiksa dan Perusahaan tidak
          akan diundang untuk mengikuti proses selanjutnya.
        </div>
      </div>
      <div class="vendor-form mt40">
        <div class="input-100" style="display:flex; align-items:center; justify-content:center">
          <input type="checkbox" value="1" v-model="selesai" disabled />
          <label class="ml20">Dengan ini menyatakan bahwa pernyataan yang telah diisi dan dokumen
            pendukung yang dilampirkan sudah benar, akurat dan lengkap serta
            menyetujui seluruh peraturan yang tertera diatas</label>
        </div>
      </div>
    </div>

    <!-- <div class="profil-btn-wrapper">
      <div
        @click="approve()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_k3l_done"
      >
        Approve
      </div>
      <div
        @click="open()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_k3l_done"
      >
        Need Review
      </div>
      <div @click="preview()" class="btn-landing">Dokumen Preview</div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div> -->
  </div>
</template>
<script>
import { api } from '../../services/config'
import axios from 'axios'
export default {
  components: {
    NeedReview: () => import('@/components/customModal/need-review.vue'),
  },
  data() {
    return {
      selesai: 1,
      catatan: '',
      is_catatan_open: false,
      is_done: false,
    }
  },
  methods: {
    preview() {
      const url = `${process.env.VUE_APP_ISUPPLIER_URL}pdf/k3l-document/${this.$route.params.id}`
      window.open(url, '_blank')
    },
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
    },
    async approve() {
      this.$store.commit('k3lStore/APPROVE_HOC')
    },
    open() {
      this.is_catatan_open = true
    },
    close() {
      this.is_catatan_open = false
    },
    async needReview(catatan) {
      // this.$store.commit('k3lStore/SUBMIT_PENILAIAN')
      const id = this.$route.params.id
      const user_id = this.$route.params.user
      const url = `${api}/api/v1/request/reviewhead-k3l/${id}`

      this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_catatan_open = false
          await this.$store.commit('SET_NOTIF', response.message)
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'is_k3l_done',
            value: true,
          })
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        this.$store.commit('k3lStore/SET_K3L_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
  },
}
</script>
